/**
 * Runs an effect once per mount.
 *
 * React 19 StrictMode mounts, unmounts and remounts every component in
 * development, so a plain useEffect(fn, []) fires twice. For the session check
 * that means two progress requests racing to set the phase. This guards with a
 * ref so the check runs once per real mount, in development and production
 * alike.
 */

import { useEffect, useRef } from 'react';

export function useEffectOnce(effect: () => void): void {
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
